import { render, staticRenderFns } from "./TransfersForm.vue?vue&type=template&id=256b4c72&scoped=true"
import script from "./TransfersForm.vue?vue&type=script&lang=js"
export * from "./TransfersForm.vue?vue&type=script&lang=js"
import style0 from "./TransfersForm.vue?vue&type=style&index=0&id=256b4c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b4c72",
  null
  
)

export default component.exports